module.exports = __webpack_public_path__ + "media/images/articles/resignation/img01-a29c0ca76ccaf78e68f55ff4175fa9e3.png";